import React from "react";
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { DropdownButton, MenuItem, Row, Grid, Col, Panel } from "react-bootstrap";
/*  import './style.css' */
import SelectFix from '../PopUp/SelectFix';
import PopupArcode from './../PopUp/PopUpArcode';
import PopUpOther2 from './../PopUp/PopUpOther';
import PopUpARInvDebt from '../PopUp/PopUpARInvDebt';
import PopUpOther4 from '../PopUp/PopUpARPaybill';
/* import PopUpOther from './../PopUp/PopUpOrher1'; */
import PopUpSearchDoc from './../PopUp/PopUpSearchDoc';
// import Dialog from 'react-bootstrap-dialog'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { parseJwt } from '../parseJWT';
import PopUpReport from "../PopUp/_fromShow";
import Checkdocgroup from './../CustomFunction/Docgroup/Checkdocgroup'
import Chackdocno from './../CustomFunction/Docno/GetDocno'
import ChackAr from './../CustomFunction/Csar/GetAr'
import CheckBrabchname from './../CustomFunction/Branch/Checkname'
import CheckDepartmentname from './../CustomFunction/Department/Checkname'
import axios from 'axios'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
// import cheackdate from './../CustomFunction/Date/Checkdate'
import { ReDate } from './../_source/Datefn'
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Topbar from "../Components/Customtopbar/Topbar";
import FullScreenDialog from './../PopUp/FullScreendialogs/FullScreen'
import Rechecked from "./Components/Rechecked";
const listmenu = [["เลือกเอกสารตั้งหนี้คงค้าง", "ARInvDebt"]]
export default class Index extends React.Component {
    customStyle = () => {
        return {
            backgroundColor: '#f2f2f2'
        };
    }
    constructor(props) {
        super(props);
        this.CustomerCode = React.createRef();
        this.CustomerName = React.createRef();
        this.Groupdata_code = React.createRef();
        this.Groupdata = React.createRef();
        this.DeliNumber = React.createRef();
        this.Currencycode = React.createRef();
        this.Remark = React.createRef();
        this.Sumpayamount = React.createRef();
        this.Department_code = React.createRef();
        this.Department = React.createRef();
        this.Branch_code = React.createRef();
        this.Branch = React.createRef();
        this.Accept = React.createRef();
        this.Account = React.createRef();
        this.state = {
            Save_status: false,
            SwitchPopupArcode: false,
            showPopupOT3: false,
            showPopupOT4: false,
            tableData: [],
            selectRow: [],
            DocType: [],
            SGstatus: true,
            DisInput: true,
            mstremark: '-',
            tfdocPrint: "",
            CHLOOP: 0,
            loading: "none",
            Currencycode: "บาท",
            Expcode: "",
            rowtb: "300",
            Groupdata_txt: "",
            Department_txt: "",
            Branch_txt: "",
            CSdelete: "",
            CSdeletes: false,
            CSdelete_yes: false,
            AmountPayable: 0,
            openBackdrop: false,
            autoClose: 3600,
            color: "warning",
            messagealert: "",
            checkenableInput: []
        }
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date = myDate.getDate();
            if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1);
            if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    ResetThisPage = (type) => {
        if (type === "NEW") {
            if (this.state.iconNoWash) {
                this.onAddValue("Groupdata", "PR");
            } else {
                this.componentDidMount();
            }
        } else if (type === "SAVE") {
            window.location.replace("/PSPaybill");
        }
    }
    async componentDidMount() {
        //เช็คเปิดปิด textbox
        await this.setState({
            checkenableInput: JSON.parse(localStorage.getItem('checkoftxt'))
        })

        let SITECODESTR = parseJwt(localStorage.getItem('Token'));
        this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
        this.setRow(this.state.rowtb);
        this.Get_UserCode(localStorage.getItem("Username"));
        this.setState({ OtPopupType: "Groupdata" });
    }
    setRow = (count) => {
        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = {
                li: i + 1,
                C0: i,
                T_Docdebt: "",
                T_Duedate: "",
                SB: "0"
            }
        }
        this.setState({ tableData: data });
    }
    deleterow = (id) => {
        var Old_HTML = ""
        if (document.getElementById(id)) {
            Old_HTML = document.getElementById(id).innerHTML;
            document.getElementById(id).innerHTML = '<i className="far fa-minus-square"></i>';
        }
    }
    Get_Arcode = async (event) => {
        if (this.CustomerCode.current.value === "") {
            this.CustomerName.current.value = "";
        }
        if (event.key === "Enter") {
            this.setState({ openBackdrop: true })
            var arcode = (event.target.value).trim();
            var url = "CSAR/CustomerCode?arcode=" + arcode + "&user=" + localStorage.getItem("Username");
            console.log(genURL(url));
            await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                if (res.data.length > 0) {
                    this.CustomerCode.current.value = res.data[0].CODE;
                    this.CustomerName.current.value = res.data[0].NAMETH;
                    this.setState({ openBackdrop: false })
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล" })
                    this.CustomerCode.current.value = "";
                    this.CustomerName.current.value = "";
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                console.log(error);
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
                this.setState({ openBackdrop: false })
            });
        }
    }
    _calprice = (e) => {
        var Sumpayamount = 0.00;
        var _sumamountC5 = 0.00;
        for (var i = 0; i < this.state.tableData.length; i++) {
            if (this.state.tableData[i].T_Payment) {
                Sumpayamount += parseFloat(this.state.tableData[i].T_Payment)
            }
            if (this.state.tableData[i].T_Residual) {
                _sumamountC5 += parseFloat(this.state.tableData[i].T_Residual)
            }
        }
        setTimeout(() => {
            this.setState({ _sumamountC5_s: _sumamountC5 })
        }, 30);
        this.Sumpayamount.current.value = Sumpayamount.toFixed(2);
        /* this.Netpayamount.current.value = parseFloat(Sumpayamount).toFixed(2);
        var Discamount = 0;
        if (this.Discamount.current.value) { Discamount = parseFloat(this.Discamount.current.value).toFixed(2); }
        this.Discamount.current.value = parseFloat(Discamount).toFixed(2);
        var Depositpayment = 0;
        if (this.Depositpayment.current.value) { Depositpayment = parseFloat(this.Depositpayment.current.value).toFixed(2); }
        this.Depositpayment.current.value = parseFloat(Depositpayment).toFixed(2);
        var Netpayamount = 0;
        if (this.Netpayamount.current.value) { Netpayamount = parseFloat(this.Netpayamount.current.value).toFixed(2); }
        this.Netpayamount.current.value = parseFloat(Netpayamount).toFixed(2);
        this.setState({ AmountPayable: this.Netpayamount.current.value }); */
    }
    Get_UserCode = (data) => {
        this.setState({ UserCode_code: localStorage.getItem("Username") });
        this.setState({ UserCode_txt: localStorage.getItem('UsernameTH') });
        this.setState({ UserCode: localStorage.getItem('UsernameTH') });
    }
    SelectSetData = (type, data) => {
        var pdata = data.split("|");
        switch (type) {
            case "Taxtype":
                this.setState({ Taxtype: pdata[1] })
                this.setState({ CTaxtype: pdata[0] });
                break;
            case "Calendar1":
                this.setState({ Docdate: data });
                break;
            case "Calendar1-up":
                this.setState({ Docdate_Recmoney: data });
                break;
            case "Calendar3":
                this.setState({ Paydate: data });
                break;
        }
    }
    SetPopup = (e) => {
        // this.setState({ PopUpTYpe: data });
        this.setState({ OtPopupType: e })
        // this.setState({ showPopupOT: !this.state.showPopupOT });
        //ชื่อ
        this.setState({ typeFullScreenDialog: e })
        //open
        this.setState({ openFullScreenDialog: true })
        if (e === "Groupdata") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" })
        }
        if (e === "Department") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" })
        }
        if (e === "Branch") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" })
        }
    }
    Switch_PopupArcode = (e) => {
        //ชื่อ
        this.setState({ typeFullScreenDialog: e })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "ค้นหาลูกค้า-AR" })
    }
    Get_PopUparcode = (data1, data2) => {
        this.CloseDialog(false)
        this.CustomerCode.current.value = data1;
        this.CustomerName.current.value = data2;
    }
    Get_PopUpOther = async (val) => {
        this.CloseDialog(false)
        var data = val.split("|");
        for (var i = 0; i < data.length; i++) {
            data[i] = data[i].trim();
        }
        switch (this.state.OtPopupType) {
            case "Groupdata":
                this.Groupdata_code.current.value = data[0]
                this.Groupdata.current.value = data[1]
                this.setState({ Groupdata_txt: data[1] });
                await Chackdocno(data[0], "CSARPAYBILL").then(async (result1) => {
                    if (result1 !== undefined) {
                        this.DeliNumber.current.value = await result1
                    } else {
                        this.DeliNumber.current.value = ""
                    }
                }).catch((err) => {
                    this.DeliNumber.current.value = ""
                    console.log(err);
                });
                break;
            case "Department":
                this.Department_code.current.value = await data[0];
                this.Department.current.value = await data[1];
                this.setState({ Department_txt: data[1] });
                break;
            case "Branch":
                this.Branch_code.current.value = await data[0];
                this.Branch.current.value = await data[1];
                this.setState({ Branch_txt: data[1] });
                break;
            default:
                break;
        }
    };
    PopUpOtherClose = (data) => {
        this.setState({ showPopupOT: !this.state.showPopupOT });
    }
    onClickDocNo = async (code) => {
        if (code) {
            var Url = "CSDOCGROUP/Code?tablename=CSARPAYBILL&code=" + code;
            console.log(genURL(Url));
            await axios.get(genURL(Url)).then(async res1 => {
                if (res1.data.length > 0) {
                    var Url1 = "CSMAXDOC/MAXDOC?tablename=CSARPAYBILL&code=" + res1.data[0].CODE;
                    console.log(genURL(Url1));
                    await axios.get(genURL(Url1)).then(res => {
                        if (res !== "error") {
                            if (typeof res.data["maxdoc"] !== "undefined") {
                                this.DeliNumber.current.value = res.data["maxdoc"];
                            } else {
                                this.DeliNumber.current.value = "";
                            }
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            return
                        }
                    }).catch(error => {
                        console.log(error);
                        this.setState({ opensnackbar: true })
                        this.setState({ color: "warning" })
                        this.setState({ icon: ErrorIcon })
                        this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
                    })
                }
            }).catch(error => {
                console.log(error);
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
            })
        } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่พบข้อมูล" })
            this.DeliNumber.current.value = "";
            // this.TAXNO.current.value = "";
        }
    }
    onRowClick = (row, col, id) => {

        let T_Payment = row.T_Payment // จำนวนเต็มเวลาคลิก
        if (col === 6 && T_Payment !== "" && T_Payment !== undefined) {
            row.T_Payment = parseFloat(T_Payment).toFixed(0)
        }

        //console.log("col"+col);
        this.setState({ _rowClick: id })
        if (col >= 1) {
            // console.log("this.state.tableData[row.C0].T_Docdebt"+this.state.tableData[row.C0].T_Docdebt);
            if (this.state.tableData[row.C0].T_Docdebt !== "") {
                let arrData_0 = this.state.tableData;
                arrData_0[row.C0].SB = "0";
                this.setState({ tableData: arrData_0 });
            } else {
                for (var i = 0; i <= this.state.rowtb - 1; i++) {
                    let arrData_0 = this.state.tableData;
                    arrData_0[i].SB = "0";
                    this.setState({ tableData: arrData_0 });
                }
            }
        }
    }
    ReLoadData = () => {
        var col = this.state.tableData
        var NewCol = [], j = 0
        for (var i = 0; i < col.length; i++) {
            if (col[i].T_Docdebt) {
                NewCol[j] = col[i]
                NewCol[j].C0 = j
                j++
            }
        }
        for (var i = j; i < col.length; i++) {
            NewCol[j] = { li: j + 1, C0: j, SB: "0" }
            j++
        }
        this.setState({ tableData: NewCol })
    }
    afterSaveCell = (row, cellName, cellValue) => {
        if (row.T_Docdebt === "" || row.T_Docdebt === undefined) {
            this.ReLoadData()
        }
        if (cellName === "T_Payment") {
            /* var data = this.state.tableData; */
            let _c5 = Number(row.T_Residual)
            let _c6 = Number(row.T_Payment).toFixed(2)
            /* let _c5 = parseFloat(data[this.state._rowClick].T_Residual).toFixed(2)
            let _c6 = parseFloat(data[this.state._rowClick].T_Payment).toFixed(2) */
            var sum = _c5 - _c6
            if (_c5 >= _c6) {
                row.T_Overdue = parseFloat(sum).toFixed(2)
                row.T_Payment = parseFloat(_c6).toFixed(2)
            } else if (_c5 < _c6) {
                row.T_Overdue = "0.00";
                row.T_Payment = _c5;
            }
            ///--------------------------------------- คำนวณเงินใหม่ -------------------------------------------------------------- 
            setTimeout(() => {
                this._calprice()
            }, 30);
        }
    }
    SetRowNull = (RowId) => {
        var data = this.state.tableData;
        for (var i = 0; i <= this.state.rowtb - 1; i++) {
            if (i === RowId) {
                data[RowId] = {
                    li: i + 1,
                    T_Docdebt: "",
                    T_Taxinvoice: "",
                    T_Datedebt: "",
                    T_Duedate: "",
                    T_Residual: "",
                    CC5: "",
                    T_Payment: "",
                    CC6: "",
                    T_Overdue: "",
                    T_Remark: "",
                    T_Category: "",
                    C10: "",
                    SELFLAG: "",
                    SELFLAG2: "",
                    usercode: "",
                    project: "",
                    allocatecode: "",
                    sitecode: "",
                    REFTAXAMOUNT: "",
                    PAYTAXAMOUNT: "",
                    INTEREST_RATE: "",
                    PAYINTEREST: "",
                    ARCODE: "",
                    ARNAME: "",
                    DOCGROUP: "",
                    PAYBILLAMOUNT: "",
                    PREPAYAMOUNT: "",
                    FACTORING: "",
                    REFAMOUNT: "",
                    DEPARTNAME: "",
                    BILLEXCHANGERATE: "",
                    CURRENCYCODE: "",
                    CURRNAME: "",
                    TRANSREFDOCNO: "",
                    REFINTEREST: ""
                }
            }
        }
        this.setState({ tableData: data });
    }
    int_format = (int) => {
        var re = 0;
        if (int) {
            re = parseFloat(int).toFixed(2);
        } else {
            re = parseFloat(re).toFixed(2);
        }
        return re;
    }
    AddDataRow = () => {
        var allrowTable = this.state.rowtb - 1;
        var data = this.state.tableData;
        var j = 0;
        for (var i = 0; i <= allrowTable; i++) {
            if (data[i].T_Docdebt !== "") {
                data[j] = {
                    li: j + 1,
                    C0: j,
                    T_Docdebt: data[i].T_Docdebt,
                    T_Taxinvoice: data[i].T_Taxinvoice,
                    T_Datedebt: data[i].T_Datedebt,
                    T_Duedate: data[i].T_Duedate,
                    T_Residual: parseFloat(data[i].T_Residual).toFixed(2),
                    T_Payment: parseFloat(data[i].T_Payment).toFixed(2),
                    T_Overdue: parseFloat(data[i].T_Residual - data[i].T_Payment).toFixed(2),
                    T_Remark: data[i].T_Remark,
                    T_Category: data[i].T_Category,
                    C10: data[i].C10,
                    CC5: data[i].CC5,
                    CC6: data[i].CC6,
                    SB: data[i].SB,
                }
                j++;
            }
        }
        this.DeletRow(j, allrowTable);
        this._calprice();
    }

    DeletRow = (str, end) => {
        var data = this.state.tableData;
        for (var i = str; i <= end; i++) {
            data[i] = {
                li: i + 1,
                C0: i,
                T_Docdebt: "",
                T_Duedate: "",
                SB: "0"
            }
        }
        this.setState({ tableData: data });
    }
    /* Getformatdatetime = (date) => {
        if (date) {
            var year = date.substring(6, 10);
            var month = date.substring(3, 5);
            var day = date.substring(0, 2);
            if (year > 2500) {
                year = year - 543;
            }
            return year + month + day;
        } else {
            return "";
        }
    } */
    saveData = async () => {
        const parameter = new URLSearchParams();
        var dataTT = [];
        var s = [];
        for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) {
            dataTT[i] =
                this.state.tableData[i].T_Docdebt + "|" +
                this.state.tableData[i].T_Taxinvoice + "|" +
                this.state.tableData[i].T_Datedebt + "|" +
                this.state.tableData[i].T_Duedate + "|" +
                // this.Getformatdatetime(this.state.tableData[i].T_Datedebt) + "|" +
                // this.Getformatdatetime(this.state.tableData[i].T_Duedate) + "|" +
                this.state.tableData[i].T_Residual + "|" +
                this.state.tableData[i].T_Payment + "|" +
                this.state.tableData[i].T_Overdue + "|" +
                this.state.tableData[i].T_Remark + "|" +
                this.state.tableData[i].CT_Category + "|" +
                this.state.tableData[i].C10 + "|" +
                this.state.tableData[i].SELFLAG + "|" +
                this.state.tableData[i].SELFLAG2 + "|" +
                this.state.tableData[i].usercode + "|" +
                this.state.tableData[i].project + "|" +
                this.state.tableData[i].allocatecode + "|" +
                this.state.tableData[i].sitecode + "|" +
                this.state.tableData[i].REFTAXAMOUNT + "|" +
                this.state.tableData[i].PAYTAXAMOUNT + "|" +
                this.state.tableData[i].INTEREST_RATE + "|" +
                this.state.tableData[i].PAYINTEREST + "|" +
                this.state.tableData[i].ARCODE + "|" +
                this.state.tableData[i].ARNAME + "|" +
                this.state.tableData[i].DOCGROUP + "|" +
                this.state.tableData[i].PAYBILLAMOUNT + "|" +
                this.state.tableData[i].PREPAYAMOUNT + "|" +
                this.state.tableData[i].FACTORING + "|" +
                this.state.tableData[i].REFAMOUNT + "|" +
                this.state.tableData[i].DEPARTNAME + "|" +
                this.state.tableData[i].BILLEXCHANGERATE + "|" +
                this.state.tableData[i].CURRENCYCODE + "|" +
                this.state.tableData[i].CURRNAME + "|" +
                this.state.tableData[i].TRANSREFDOCNO + "|" +
                this.state.tableData[i].REFINTEREST
            s.push(dataTT[i])
        }
        console.log(s);
        parameter.append("listitem", s);
        parameter.append("CREATEUSER", localStorage.getItem('Username'));
        parameter.append("SYSCREATE", this.state.Docdate);
        parameter.append("PAYDATE", this.state.Paydate);
        parameter.append("ARCODE", this.CustomerCode.current.value);
        parameter.append("ARNAME", this.CustomerName.current.value);
        parameter.append("CURRENCYCODE", "TH");
        parameter.append("DOCGROUP", this.Groupdata_code.current.value);
        parameter.append("DOCNO", this.DeliNumber.current.value);
        parameter.append("REMARK", this.Remark.current.value);
        parameter.append("DEPARTMENT", this.Department_code.current.value);
        parameter.append("SITECODE", this.Branch_code.current.value);
        parameter.append("SUMPAYAMOUNT", this.Sumpayamount.current.value);
        parameter.append("sumallmoney", this.state._sumamountC5_s)
        if (this.Accept.current.value === "" || this.Account.current.value === "") {
            parameter.append("Docdate_Recmoney", "");
            parameter.append("Name_Recmoney", "");
            parameter.append("Account_Rec", "");
        } else {
            parameter.append("Docdate_Recmoney", this.state.Docdate_Recmoney);
            parameter.append("Name_Recmoney", this.Accept.current.value);
            parameter.append("Account_Rec", this.Account.current.value);
        }
        var Uststus = true;
        for (var pair of parameter.entries()) {
            console.log(pair);
            if (pair[0] === "SYSCREATE" && pair[1] === "") {
                Uststus = false;
                // this.Docdate.focus()
            }
            if (pair[0] === "DOCNO" && pair[1] === "") {
                Uststus = false;
                // this.Groupdata.focus()
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "เลขที่เอกสารไม่ควรเป็นค่าว่าง" })

            }
            if (pair[0] === "listitem" && pair[1] === "") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "รายการในตารางต้องไม่เป็นค่าว่าง" })
            }
            if (pair[0] === "DEPARTMENT" && pair[1] === "") {
                Uststus = false;
                // this.Department.focus()
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "แผนกต้องไม่เป็นค่าว่าง" })
            }
            if (pair[0] === "SITECODE" && pair[1] === "") {
                Uststus = false;
                //this.Branch.focus()
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "สาขาต้องไม่เป็นค่าว่าง" })
            }
        }
        if (Uststus === false) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ข้อมูลไม่ครบ" })
        }
        if (Uststus === true) {
            this.setState({ openBackdrop: true })
            let url = "CSARPAYBILL/save?="
            await axios.post(genpostURL(url), parameter).then(res => {
                console.log(res.data);
                if (res.data === "1") {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "success" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกสำเร็จ" })
                    setTimeout(() => {
                        this.ResetThisPage("SAVE");
                        this.setState({ openBackdrop: false })
                    }, 1500);
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกไม่สำเร็จ" + res.data })
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
                this.setState({ openBackdrop: false })
            });
        }
    }
    chkdata = (data) => {
        var redata = "";
        if (data !== "null") {
            redata = data;
        }
        return redata;
    }
    //--------------------------------popup3
    SetPopup3 = (data) => {
        if (this.CustomerCode.current.value) {
            this.setState({ PopUpTYpe3: data });
            // this.setState({ showPopupOT3: !this.state.showPopupOT3 });
            //ชื่อ
            this.setState({ typeFullScreenDialog: data })
            //open
            this.setState({ openFullScreenDialog: true })
            //title
            this.setState({ titleFullScreenDialog: "เลือกเอกสารตั้งลูกหนี้คงค้าง-ArinvDebt" })
        } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาใส่! รหัสลูกหนี้" })
        }
    }
    REFDOCTYPE_TXT = (data) => {
        switch (data) {
            case "0":
                return "บิลขายเชื่อ"
                break;
            case "1":
                return "ลดหนี้การค้า"
                break;
            case "2":
                return ""
                break;
            case "3":
                return "ตั้งหนี้อื่นๆ"
                break;
            case "4":
                return "ลดหนี้อื่นๆ"
                break;
            case "5":
                return "ตั้งหนี้ยกมา"
                break;
            default: break;
        }
    }
    Get_PopUpOther3 = (data) => {
        this.CloseDialog(false)
        this.setdelete_no();
        var split_data = data.split("|");
        switch (this.state.PopUpTYpe3) {
            case "ARInvDebt":
                for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) { }
                if (i > this.state.rowtb - 1) {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "รายการข้อมูลเกินกำหนด" })
                    return;
                }
                let arrData = this.state.tableData;
                var vc5 = split_data[8];
                var vc6 = split_data[8];
                arrData[i].T_Docdebt = this.chkdata(split_data[0]);
                arrData[i].T_Taxinvoice = this.chkdata(split_data[1]);
                arrData[i].T_Datedebt = this.chkdata(split_data[2]);
                arrData[i].T_Duedate = this.chkdata(split_data[4]);
                arrData[i].T_Residual = this.chkdata(parseFloat(vc5).toFixed(2));
                arrData[i].T_Payment = this.chkdata(parseFloat(vc6).toFixed(2));
                arrData[i].T_Overdue = this.chkdata(parseFloat(vc5 - vc6).toFixed(2));
                arrData[i].T_Remark = this.chkdata(split_data[9]);
                arrData[i].T_Category = this.REFDOCTYPE_TXT(split_data[10]);
                arrData[i].CT_Category = split_data[10];
                arrData[i].C10 = "";
                arrData[i].SELFLAG = this.chkdata(split_data[11]);
                arrData[i].SELFLAG2 = this.chkdata(split_data[12]);
                arrData[i].usercode = this.chkdata(split_data[13]);
                arrData[i].project = this.chkdata(split_data[14]);
                arrData[i].allocatecode = this.chkdata(split_data[15]);
                arrData[i].sitecode = this.chkdata(split_data[16]);
                arrData[i].REFTAXAMOUNT = this.chkdata(split_data[17]);
                arrData[i].PAYTAXAMOUNT = this.chkdata(split_data[18]);
                arrData[i].INTEREST_RATE = this.chkdata(split_data[19]);
                arrData[i].PAYINTEREST = this.chkdata(split_data[20]);
                arrData[i].ARCODE = this.chkdata(split_data[21]);
                arrData[i].ARNAME = this.chkdata(split_data[22]);
                arrData[i].DOCGROUP = this.chkdata(split_data[23]);
                arrData[i].PAYBILLAMOUNT = this.chkdata(split_data[24]);
                arrData[i].PREPAYAMOUNT = this.chkdata(split_data[25]);
                arrData[i].FACTORING = this.chkdata(split_data[26]);
                arrData[i].REFAMOUNT = this.chkdata(split_data[27]);
                arrData[i].DEPARTNAME = this.chkdata(split_data[28]);
                arrData[i].BILLEXCHANGERATE = this.chkdata(split_data[29]);
                arrData[i].CURRENCYCODE = this.chkdata(split_data[30]);
                arrData[i].CURRNAME = this.chkdata(split_data[31]);
                arrData[i].TRANSREFDOCNO = this.chkdata(split_data[32]);
                arrData[i].REFINTEREST = this.chkdata(split_data[33]);

                this.setState({ tableData: arrData });


                this._calprice();
                break;
        }
        this.setState({ showPopupOT3: !this.state.showPopupOT3 });
    }
    PopUpOtherClose3 = () => {
        this.setState({ showPopupOT3: !this.state.showPopupOT3 });
    }
    //-------------------ลบแถว
    setdelete_load = () => {
        this.setState({ CSdelete: "" });
        this.setState({ CSdeletes: false });
        this.setState({ CSdelete_yes: false });
    }

    setdelete_no = () => {
        this.setState({ CSdelete: "far fa-square" });
        this.setState({ CSdeletes: false });
        this.setState({ CSdelete_yes: false });
    }
    setdelete_yes = () => {
        this.setState({ CSdelete: "fas fa-trash-alt" });
        this.setState({ CSdeletes: true });
        this.setState({ CSdelete_yes: true });
    }

    selectRowData = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.tableData[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0":
                if (this.state.tableData[rowIndex].T_Docdebt !== "") {
                    btnShow = < span >  < i className="" style={{ fontSize: '20px' }} onClick={this.Update_Status.bind(null, rowIndex, "1")} > {row.li} </i> </span>;
                } else {
                    btnShow = < span > < i className="" style={{ fontSize: '20px' }} > {row.li} </i> </span>;
                }
                break;
            case "1":
                btnShow = < span >
                    <i style={
                        { color: '#ff0000', marginTop: '3px' }}
                        className="far fa-minus-square"
                        onClick={this.Update_Status.bind(null, rowIndex, "0")} > </i> </span>;
                break;
            default:
                btnShow = < span > < i className="" > </i></span >;

        }
        return (<div> {btnShow} </div>)
    }
    deleterowall = (Row, Status) => {
        if (this.state.CSdeletes === false) {
            var dataArray = this.state.tableData;
            for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) {
                dataArray[i].SB = "1";
                this.setState({ tableData: dataArray });
            }
            if (i > 0) {
                this.setdelete_yes();
                this.setState({ CSdeletes: !this.state.CSdeletes });
            }
        }
        if (this.state.CSdelete_yes === true) {
            var dataArray = this.state.tableData;
            for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) {
                if (this.state.tableData[i].SB === 1) {
                    dataArray[i].T_Docdebt = "";
                }
            }
            this.setState({ tableData: dataArray });
            this.AddDataRow();
            this.setdelete_load();
        }
    }
    Update_Status = (Row, Status) => {
        if (Status === 0) {
            var dataArray = this.state.tableData;
            dataArray[Row].T_Docdebt = "";
            this.setState({ tableData: dataArray });
            this.AddDataRow();

            for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) { }
            if (i <= 0) {
                this.setdelete_load();
            }

        } else {
            var dataArray = this.state.tableData;
            dataArray[Row].SB = Status;
            this.setState({ tableData: dataArray });
            var chk_all = 0;
            var chk_all_y = 0;
            for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) {
                chk_all_y = chk_all_y + 1;
                if (this.state.tableData[i].SB === 1) {
                    chk_all = chk_all + 1;
                }
            }
            if (chk_all === chk_all_y && chk_all_y > 0) {
                this.setdelete_yes();
            }
        }
    }
    ReplaceThisPage = async (RowData) => {
        this.CloseDialog(false)
        this.setState({ Save_status: "disabled" });
        var url = "CSARPAYBILL/Getbycodemain?code=" + RowData.C2;
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data !== "") {
                this.CustomerCode.current.value = res.data[0].ARCODE;
                this.CustomerName.current.value = res.data[0].ARNAME;
                this.DeliNumber.current.value = res.data[0].DOCNO;
                this.Remark.current.value = res.data[0].REMARK;
                this.Sumpayamount.current.value = res.data[0].SUMPAYAMOUNT;
                this.Accept.current.value = res.data[0].Name_Recmoney;
                this.Account.current.value = res.data[0].Account_Rec;
                this.setState({ Docdate_Recmoney: (res.data[0].Docdate_Recmoney == null) ? "" : ReDate(res.data[0].Docdate_Recmoney) })
                this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y")
                this.onAddValue("Department", res.data[0].DEPARTMENT);
                this.onAddValue("Branch", res.data[0].SITECODE);
            }
        }).catch(error => {
            console.log(error);
        });
        var url = "CSARPAYBILL/Getbycodesub?code=" + RowData.C2;
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data !== "") {
                let arrData = this.state.tableData;
                for (var i = 0; i < res.data.length; i++) {
                    arrData[i].T_Docdebt = res.data[i].REFDOCNO;
                    arrData[i].T_Taxinvoice = res.data[i].REFTAXNO;
                    arrData[i].T_Datedebt = this.GetformatTimestamp(res.data[i].REFDOCDATE);
                    arrData[i].T_Duedate = this.GetformatTimestamp(res.data[i].REFDUEDATE);
                    arrData[i].T_Residual = res.data[i].REFAMOUNT;
                    arrData[i].T_Payment = res.data[i].PAYAMOUNT;
                    arrData[i].T_Overdue = parseFloat(res.data[i].REFBALANCE).toFixed(2);
                    arrData[i].T_Remark = res.data[i].REMARK;
                    arrData[i].T_Category = this.REFDOCTYPE_TXT(res.data[i].REFDOCTYPE.toString())
                    arrData[i].CT_Category = res.data[i].REFDOCTYPE.toString()
                    this.setState({ tableData: arrData });
                }
            }
        }).catch(error => {
            console.log(error);
        });
    }
    _print = (e) => {
        if (!this.DeliNumber.current.value) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกเลขที่เอกสาร" })
        } else {
            this._callForm(this.DeliNumber.current.value);
        }
    }
    _callForm = (vel) => {
        let url1 = "https://csrpt.pspl.co.th/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FCSARRECEIPT&standAlone=true&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&j_username=rpt&j_password=042615116&output=pdf&docno=" + vel;
        this.setState({ urlsend: url1 })
        setTimeout(() => {
            this.switchshowform();
        }, 100);
    }
    switchshowform = (e) => {
        this.setState({ showform: !this.state.showform });
    }
    _saveConnection = () => {
        if (this.state.tableData.length === 0) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกรายการ" })
            this.setState({ Uststus: false });
            return;
        } else if (this.CustomerCode.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" })
            this.setState({ Uststus: false });
            return;
        } else if (this.state.DOCGROUP_code === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" })
            this.setState({ Uststus: false });
            return;
        } else if (this.state.Department_code === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกแผนก" })
            this.setState({ Uststus: false });
            return;
        } else if (this.state.SiteCode_code === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกสาขา" })
            this.setState({ Uststus: false });
            return;
        }
    }
    onSearch = (e) => {
        var data = this.state.tableData
        for (var i = 0; i < data.length; i++) {
            data[i].T_Docdebt = "";
            data[i].T_Taxinvoice = "";
            data[i].T_Datedebt = "";
            data[i].T_Duedate = "";
            data[i].T_Residual = "";
            data[i].C5_insert = "";
            data[i].T_Payment = "";
            data[i].T_Overdue = "";
            data[i].T_Remark = "";
            data[i].T_Category = "";
            data[i].discount = "";
            data[i].C10 = "";
            data[i].C11 = "";
            this.setState({ products: data });
        }
    }
    //---------------------new by kate--------------------------
    onAddValue = async (type, value, Fix) => {
        if (type === "Groupdata") {
            Checkdocgroup(value, "CSARPAYBILL").then(async (result) => {
                if (result !== "") {
                    this.Groupdata_code.current.value = value
                    this.Groupdata.current.value = result
                    this.setState({ Groupdata_txt: result });
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล!" })
                    this.Groupdata_code.current.value = ""
                    this.Groupdata.current.value = ""
                    this.setState({ Groupdata_txt: "" });
                }
            }).catch((err) => {
                this.Groupdata_code.current.value = ""
                this.Groupdata.current.value = ""
                this.setState({ Groupdata_txt: "" });
                console.log(err);
            });
            if (Fix !== "Y") {
                await Chackdocno(value, "CSARPAYBILL").then((result1) => {
                    if (result1 !== "") {
                        this.DeliNumber.current.value = result1
                    } else {
                        this.DeliNumber.current.value = ""
                    }
                }).catch((err) => {
                    this.DeliNumber.current.value = ""
                    console.log(err);
                });
            }
        }
        if (type === "CustomerCode") {
            await ChackAr(value).then((result) => {
                console.log(result);
                if (result !== "") {
                    let data = result.split("|")
                    this.CustomerCode.current.value = value
                    this.CustomerName.current.value = data[0]
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล!" })
                    this.CustomerCode.current.value = ""
                    this.CustomerName.current.value = ""
                }
            }).catch((err) => {
                this.CustomerCode.current.value = ""
                this.CustomerName.current.value = ""
                console.log(err);
            });
        }
        if (type === "Department") {
            await CheckDepartmentname(value).then((result) => {
                console.log(result);
                if (result !== "") {
                    this.Department_code.current.value = value
                    this.Department.current.value = result
                    this.setState({ Department_txt: result });
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล!" })
                    this.Department_code.current.value = ""
                    this.Department.current.value = ""
                    this.setState({ Department_txt: "" });
                }
            }).catch((err) => {
                this.Department_code.current.value = ""
                this.Department.current.value = ""
                this.setState({ Department_txt: "" });
                console.log(err);
            });
        }
        if (type === "Branch") {
            await CheckBrabchname(value).then((result) => {
                if (result !== "") {
                    this.Branch_code.current.value = value
                    this.Branch.current.value = result
                    this.setState({ Branch_txt: result })
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล!" })
                    this.Branch_code.current.value = ""
                    this.Branch.current.value = ""
                    this.setState({ Branch_txt: "" })
                }
            }).catch((err) => {
                this.Branch_code.current.value = ""
                this.Branch.current.value = ""
                this.setState({ Branch_txt: "" })
                console.log(err);
            });
        }
    };
    onClick = (e) => {
        if (e.target.value !== "") {
            switch (e.target.name) {
                case "Groupdata":
                    this.Groupdata.current.value = this.Groupdata_code.current.value
                    break;
                case "Issuetype":
                    this.Issuetype.current.value = this.Issuetype_code.current.value
                    break;
                case "Department":
                    this.Department.current.value = this.Department_code.current.value
                    break;
                case "Branch":
                    this.Branch.current.value = this.Branch_code.current.value
                    break;
                default:
                    break;
            }
        }
    }
    onKeyDown = (e) => {
        if (e.key === "Enter") {
            if (e.target.name === "Groupdata") {
                this.onAddValue("Groupdata", e.target.value);
            }
            if (e.target.name === "CustomerCode") {
                this.onAddValue("CustomerCode", e.target.value);
            }
            if (e.target.name === "Issuetype") {
                this._chkData("Issuetype", e.target.value);
            }
            if (e.target.name === "Department") {
                this.onAddValue("Department", e.target.value);
            }
            if (e.target.name === "Branch") {
                this.onAddValue("Branch", e.target.value);
            }
        }
    };
    onChange = (e) => {
        switch (e.target.name) {
            case 'Groupdata':
                if (e.target.value === "") {
                    this.setState({ Groupdata_txt: "" })
                    this.Groupdata_code.current.value = "";
                    this.DeliNumber.current.value = "";
                }
                break;
            case 'CustomerCode':
                if (e.target.value === "") {
                    this.CustomerCode.current.value = "";
                    this.CustomerName.current.value = "";
                }
                break;
            case "Issuetype":
                if (this.Issuetype.current.value === "") {
                    this.setState({ Issuetype_txt: "" })
                    this.Issuetype_code.current.value = "";
                }
                break;
            case 'Department':
                if (e.target.value === "") {
                    this.setState({ Department_txt: "" })
                    this.state.Department_txt = ""
                }
                break;
            case 'Branch':
                if (e.target.value === "") {
                    this.setState({ Branch_txt: "" })
                    this.Branch_code.current.value = ""
                }
                break;
            default:
                break;
        }
    }
    onBlur = (e) => {
        if (e.target.name === "Groupdata") {
            this.Groupdata.current.value = this.state.Groupdata_txt;
        }
        if (e.target.name === "Issuetype") {
            this.Issuetype.current.value = this.state.Issuetype_txt;
        }
        if (e.target.name === "Department") {
            this.Department.current.value = this.state.Department_txt;
        }
        if (e.target.name === "Branch") {
            this.Branch.current.value = this.state.Branch_txt;
        }
        // if (e.target.name === "Docdate") {
        //     if (e.target.value !== "") {
        //         this.state.Docdate = cheackdate(this.state.Docdate)
        //         setTimeout(() => {
        //             if (cheackdate(this.state.Docdate) === "") {
        //                 this.Docdate.current.focus()
        //                 this.setState({ opensnackbar: true })
        //                 this.setState({ color: "warning" })
        //                 this.setState({ icon: ErrorIcon })
        //                 this.setState({ messagealert: "รูปแบบวันที่ไม่ถูกต้อง" })
        //             }
        //         }, 500);
        //     }
        // }
        // if (e.target.name === "Paydate") {
        //     if (e.target.value !== "") {
        //         this.state.Paydate = cheackdate(this.state.Paydate)
        //         setTimeout(() => {
        //             if (cheackdate(this.state.Paydate) === "") {
        //                 this.Paydate.current.focus()
        //                 this.setState({ opensnackbar: true })
        //                 this.setState({ color: "warning" })
        //                 this.setState({ icon: ErrorIcon })
        //                 this.setState({ messagealert: "รูปแบบวันที่ไม่ถูกต้อง" })
        //             }
        //         }, 500);
        //     }
        // }
        // if (e.target.name === "Docdate_Recmoney") {
        //     if (e.target.value !== "") {
        //         this.state.Docdate_Recmoney = cheackdate(this.state.Docdate_Recmoney)
        //         setTimeout(() => {
        //             if (cheackdate(this.state.Docdate_Recmoney) === "") {
        //                 this.Docdate_Recmoney.current.focus()
        //                 this.setState({ opensnackbar: true })
        //                 this.setState({ color: "warning" })
        //                 this.setState({ icon: ErrorIcon })
        //                 this.setState({ messagealert: "รูปแบบวันที่ไม่ถูกต้อง" })
        //             }
        //         }, 500);
        //     }
        // }
    };
    onClickTopbar = (e) => {
        console.log(e);
        switch (e) {
            case "save":
                this.saveData()
                break;
            case "new":
                this.ResetThisPage("SAVE")
                break;
            case "print":
                this._print(null)
                break;
            case "search":
                this.onSearch();
                // this.setState({ SwitchSearchDoc: true });
                //ชื่อ
                this.setState({ typeFullScreenDialog: e })
                //open
                this.setState({ openFullScreenDialog: true })
                //title
                this.setState({ titleFullScreenDialog: "ใบวางบิล" })
                break;
            case "ARInvDebt":
                this.SetPopup3("ARInvDebt")
                break;
            default:
                break;
        }
    }
    CloseDialog = (e) => {
        this.setState({ openFullScreenDialog: e })
    }

    _reCHK = async (val) => {

        console.log("val", val);
        this.CloseDialog(false)
        this.setState({ Save_status: "disabled" });
        var url = "CSARPAYBILL/Getbycodemain?code=" + val[0].docNo;
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            console.log("_reCHK", res);
            if (res.data !== "") {
                this.CustomerCode.current.value = res.data[0].ARCODE;
                this.CustomerName.current.value = res.data[0].ARNAME;
                this.DeliNumber.current.value = res.data[0].DOCNO;
                this.Remark.current.value = res.data[0].REMARK;
                this.Sumpayamount.current.value = res.data[0].SUMPAYAMOUNT;
                this.Accept.current.value = res.data[0].Name_Recmoney;
                this.Account.current.value = res.data[0].Account_Rec;
                this.setState({ Docdate_Recmoney: (res.data[0].Docdate_Recmoney == null) ? "" : ReDate(res.data[0].Docdate_Recmoney) })
                this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y")
                this.onAddValue("Department", res.data[0].DEPARTMENT);
                this.onAddValue("Branch", res.data[0].SITECODE);
            }
        }).catch(error => {
            console.log(error);
        });
        var url = "CSARPAYBILL/Getbycodesub?code=" + val[0].docNo;
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data !== "") {
                let arrData = this.state.tableData;
                for (var i = 0; i < res.data.length; i++) {
                    arrData[i].T_Docdebt = res.data[i].REFDOCNO;
                    arrData[i].T_Taxinvoice = res.data[i].REFTAXNO;
                    arrData[i].T_Datedebt = this.GetformatTimestamp(res.data[i].REFDOCDATE);
                    arrData[i].T_Duedate = this.GetformatTimestamp(res.data[i].REFDUEDATE);
                    arrData[i].T_Residual = res.data[i].REFAMOUNT;
                    arrData[i].T_Payment = res.data[i].PAYAMOUNT;
                    arrData[i].T_Overdue = parseFloat(res.data[i].REFBALANCE).toFixed(2);
                    arrData[i].T_Remark = res.data[i].REMARK;
                    arrData[i].T_Category = this.REFDOCTYPE_TXT(res.data[i].REFDOCTYPE.toString())
                    arrData[i].CT_Category = res.data[i].REFDOCTYPE.toString()
                    this.setState({ tableData: arrData });
                }
            }
        }).catch(error => {
            console.log(error);
        });
    }
    render() {
        const cellEditProp = {
            mode: 'click',
            blurToSave: true,
            afterSaveCell: this.afterSaveCell,
            blurToSave: true,
        }
        const options = {
            onRowClick: this.onRowClick,
            onMouseLeave: this.onMouseLeave,
            insertBtn: this.createCustomInsertButton,
        }
        const type = this.state.typeFullScreenDialog
        return (
            <div className="PSApp" onClick={this.onClick} onKeyDown={this.onKeyDown} onChange={this.onChange} onBlur={this.onBlur}>
                <Backdrop open={this.state.openBackdrop} />
                <FullScreenDialog open={this.state.openFullScreenDialog} title={this.state.titleFullScreenDialog} closeDialog={e => this.CloseDialog(e)}>
                    {type === "search" ?
                        <Rechecked Dataselect={e => this._reCHK(e)} from="CSARPAYBILL" />
                        // <PopUpSearchDoc closePopup={e => this.CloseDialog(e)} Get_Popup={this.ReplaceThisPage} from="CSARPAYBILL" />
                        : null}
                    {type === "Groupdata" || type === "Department" || type === "Branch" ? <PopUpOther2 closePopup={e => this.CloseDialog(e)} Get_PopUpOther={this.Get_PopUpOther} type={this.state.OtPopupType} Data={this.state.valuePopup} from="CSARPAYBILL" userSite={this.state.siteCodeUser} /> : null}
                    {type === "Search_ARCode" ? <PopupArcode closePopup={e => this.CloseDialog(e)} Get_PopUparcode={this.Get_PopUparcode} /> : null}
                    {type === "ARInvDebt" ? <PopUpARInvDebt Get_PopUpOther3={this.Get_PopUpOther3} type={this.state.PopUpTYpe3} Data={this.state.valuePopup3} ARCODE={this.CustomerCode.current.value} from="CSARPAYBILL" /> : null}
                </FullScreenDialog>
                {this.state.showform ? (<PopUpReport close={this.switchshowform} url={this.state.urlsend} />) : null}
                {/* {this.state.SwitchSearchDoc ? <PopUpSearchDoc closePopup={() => { this.setState({ SwitchSearchDoc: !this.state.SwitchSearchDoc }) }} Get_Popup={this.ReplaceThisPage} from="CSARPAYBILL" /> : null} */}
                {/* {this.state.SwitchPopupArcode ? <PopupArcode closePopup={this.Switch_PopupArcode} Get_PopUparcode={this.Get_PopUparcode} /> : null} */}
                {/* {this.state.showPopupOT ? <PopUpOther2 closePopup={this.PopUpOtherClose} Get_PopUpOther={this.Get_PopUpOther} type={this.state.OtPopupType} Data={this.state.valuePopup} from="CSARPAYBILL" userSite={this.state.siteCodeUser} /> : null} */}
                {/* {this.state.showPopupOT3 ? <PopUpARInvDebt closePopup={this.PopUpOtherClose3} Get_PopUpOther3={this.Get_PopUpOther3} type={this.state.PopUpTYpe3} Data={this.state.valuePopup3} ARCODE={this.CustomerCode.current.value} from="CSARPAYBILL" /> : null} */}
                <Topbar
                    listmenu={listmenu}
                    title="บันทึกใบวางบิล"
                    onClick={e => this.onClickTopbar(e)}
                />
                <div className="PSAppfrom">
                    <Grid>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row className="show-grid">
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> รหัสลูกหนี้  </span>
                                                <input id="1" type="text" className="form-control " name="CustomerCode" ref={this.CustomerCode} />
                                                <span id="iconCustomerCode" className="input-group-addon icon" onClick={() => this.Switch_PopupArcode("Search_ARCode")}>  <i > <ArrowDropDownRoundedIcon fontSize="small" /></i> </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={8} md={8} lg={8}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span id="2" className="input-group-addon icon"><i className="fas fa-user"></i></span>
                                                <input id="3" type="text" className="form-control " ref={this.CustomerName} name="CustomerName" onKeyDown={this.onKeyPressValue} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        {/* <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> วันที่เอกสาร  </span>
                                                <input id="4" type="text" className="form-control " name="Docdate" ref={this.Docdate}  />
                                                <span className="input-group-addon icon">
                                                    <SelectFix type={"Calendar1"} SelectSetData={this.SelectSetData} />
                                                </span>
                                            </div>
                                        </div> */}
                                        <MaterialUIPickers title="วันที่เอกสาร"
                                            DateValue={e => this.SelectSetData("Calendar1", e)}
                                            defaultdate={this.state.Docdate}
                                            open={this.state.checkenableInput['DOCDATE']}
                                        // open={this.state.checkenableInput.DocDate}
                                        />
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> กลุ่มข้อมูล  </span>
                                                <input type="hidden" ref={this.Groupdata_code} />
                                                <input id="5" type="text" className="form-control " name="Groupdata" ref={this.Groupdata} />
                                                <span id="Docgroup" className="input-group-addon icon" onClick={this.SetPopup.bind(null, "Groupdata")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> เลขที่เอกสาร  </span>
                                                <input id="6" type="text" className="form-control " name="DeliNumber" ref={this.DeliNumber} onClick={this.onClickDocNo} readOnly={this.state.OpenTAXNO} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        {/* <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> วันที่นัดชำระ  </span>
                                                <input id="7" type="text" className="form-control " name="Paydate" ref={this.Paydate} /> 
                                                <span className="input-group-addon icon">
                                                    <SelectFix type={"Calendar3"} SelectSetData={this.SelectSetData} />
                                                </span>
                                            </div>
                                        </div> */}
                                        <MaterialUIPickers title="วันที่นัดชำระ"
                                            DateValue={e => this.SelectSetData("Calendar3", e)}
                                            defaultdate={this.state.Paydate} />
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="form-group input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                                                <span className="input-group-addon"> สกุลเงิน  </span>
                                                <input id="8" type="text" className="form-control " name="Taxtype" ref={this.Currencycode} value="บาท" disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Grid>
                </div>

                <div className='container-fluid'>
                    <div className="PSAppTable">
                        <BootstrapTable
                            //bordered={ false }
                            data={this.state.tableData}
                            cellEdit={cellEditProp}
                            //selectRow={ selectRowProp }
                            options={options}
                            trClassName='trClassName'
                            tableHeaderClass='trClassName'
                            //keyBoardNav={{enterToEdit: true}}
                            // keyBoardNav={keyBoardNav}
                            height='400' hover
                            scrollTop={'Bottom'} >
                            <TableHeaderColumn row='0' dataAlign="center">  <div onClick={this.deleterowall.bind(null, "", "ALL")}> <i style={{ fontSize: '16px', marginTop: '5px' }} className={this.state.CSdelete}> </i> </div>  </TableHeaderColumn>
                            <TableHeaderColumn row='1' width="4%" dataField='li' editable={false} dataAlign="center" dataFormat={this.selectRowData.bind(this)} > </TableHeaderColumn>
                            <TableHeaderColumn row='0' dataAlign="center" > เอกสารตั้งหนี้ </TableHeaderColumn>
                            <TableHeaderColumn row='1' dataField='T_Docdebt' width="18%" editable={false} dataAlign="left" ></TableHeaderColumn>
                            <TableHeaderColumn row='0' dataAlign="center" > ใบกำกับภาษี </TableHeaderColumn>
                            <TableHeaderColumn row='1' dataField='T_Taxinvoice' width="18%" editable={false} ></TableHeaderColumn>
                            <TableHeaderColumn row='0' dataAlign="center" width="10%" > วันที่ตั้งหนี้ </TableHeaderColumn>
                            <TableHeaderColumn row='1' dataField='T_Datedebt' editable={false} ></TableHeaderColumn>
                            <TableHeaderColumn row='0' dataAlign="center" width="10%" > ครบกำหนด </TableHeaderColumn>
                            <TableHeaderColumn row='1' dataField='T_Duedate' editable={false} ></TableHeaderColumn>
                            <TableHeaderColumn row='0' width="10%" dataAlign="right" > มูลค่าคงเหลือ </TableHeaderColumn>
                            <TableHeaderColumn row='1' dataField='T_Residual' dataAlign="right" editable={false} ></TableHeaderColumn>
                            <TableHeaderColumn row='0' width="10%" dataAlign="right" > รับชำระ < i id="t_sitecode" style={{ fontSize: "10px" }} > </i></TableHeaderColumn >
                            <TableHeaderColumn row='1' dataField='T_Payment' editable={true} dataAlign="right" ></TableHeaderColumn>
                            <TableHeaderColumn row='0' dataAlign="right" width="10%" > คงค้าง </TableHeaderColumn>
                            <TableHeaderColumn row='1' dataField='T_Overdue' editable={false} dataAlign="right" ></TableHeaderColumn>
                            <TableHeaderColumn row='0' dataAlign="center" width="10%" > หมายเหตุ </TableHeaderColumn>
                            <TableHeaderColumn row='1' dataField='T_Remark' ></TableHeaderColumn>
                            <TableHeaderColumn row='0' dataAlign="center" width="10%" > ประเภท </TableHeaderColumn>
                            <TableHeaderColumn row='1' dataField='T_Category' editable={false} ></TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='C0' dataAlign="center" isKey > C0 </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='CC5' > CC5 </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='CC6' > CC6 </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='SB' > SB </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='REFDOCTYPE' > REFDOCTYPE </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='SELFLAG' > SELFLAG </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='SELFLAG2' > SELFLAG2 </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='usercode' > usercode </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='project' > project </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='allocatecode' > allocatecode </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='sitecode' > sitecode </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='REFTAXAMOUNT' > REFTAXAMOUNT </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='PAYTAXAMOUNT' > PAYTAXAMOUNT </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='INTEREST_RATE' > INTEREST_RATE </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='PAYINTEREST' > PAYINTEREST </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='ARCODE' > ARCODE </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='ARNAME' > ARNAME </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='DOCGROUP' > DOCGROUP </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='PAYBILLAMOUNT' > PAYBILLAMOUNT </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='PREPAYAMOUNT' > PREPAYAMOUNT </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='FACTORING' > FACTORING </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='REFAMOUNT' > REFAMOUNT </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='DEPARTNAME' > DEPARTNAME </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='BILLEXCHANGERATE' > BILLEXCHANGERATE </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='CURRENCYCODE' > CURRENCYCODE </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='CURRNAME' > CURRNAME </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='TRANSREFDOCNO' > TRANSREFDOCNO </TableHeaderColumn>
                            <TableHeaderColumn row='0' hidden={true} editable={false} dataField='REFINTEREST' > REFINTEREST </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                    <Grid>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row className="show-grid">
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon "> รวมรับชำระ  </span>
                                                <input id="9" type="text" className="form-control Price" name="Sumpayamount" ref={this.Sumpayamount} disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> แผนก  </span>
                                                <input type="hidden" ref={this.Department_code} />
                                                <input id="10" type="text" className="form-control " name="Department" ref={this.Department} />
                                                <span id="CSDEPARTMENT" className="input-group-addon icon" onClick={this.SetPopup.bind(null, "Department")}>
                                                    <i><ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon">  สาขา  </span>
                                                <input type="hidden" ref={this.Branch_code} />
                                                <input id="11" type="text" className="form-control " name="Branch" ref={this.Branch} />
                                                <span id="sitecode" className="input-group-addon icon" onClick={this.SetPopup.bind(null, "Branch")} >
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={8} md={8} lg={8}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> หมายเหตุ  </span>
                                                <input id="12" type="text" className="form-control " name="Remark" ref={this.Remark} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Row className="show-grid">
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Panel>
                                    <Panel.Heading>
                                        <Panel.Title componentClass="h5">ข้อมูลเพิ่มเติม ( User's Field) </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <Col xs={12} sm={12} md={12} lg={12} >
                                            <Row className="show-grid">
                                                <Col xs={12} sm={12} md={12} lg={4}>

                                                    <MaterialUIPickers title="วันที่รับเงิน"
                                                        DateValue={e => this.SelectSetData("Calendar1-up", e)}
                                                        defaultdate={this.state.Docdate_Recmoney} />
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={4}>
                                                    <div className="row">
                                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                                <span className="input-group-addon "> รับในนาม  </span>
                                                                <input id="14" type="text" className="form-control " name="Accept" ref={this.Accept} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xs={12} sm={12} md={12} lg={4}>
                                                    <div className="row">
                                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                                <span className="input-group-addon "> รับเข้าบัญชี  </span>
                                                                <input id="15" type="text" className="form-control " name="Account" ref={this.Account} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Panel.Body>
                                </Panel>
                            </Col>
                        </Row>
                    </Grid>
                    <Snackbar place="br"
                        color={this.state.color}
                        icon={this.state.icon}
                        autoClose={this.state.autoClose}
                        message={this.state.messagealert}
                        open={this.state.opensnackbar}
                        closeNotification={() => { this.setState({ opensnackbar: false }) }}
                        close />
                </div>
            </div>
        );
    }
}